export default __webpack_public_path__ + "static/media/photo.0284938c.jpeg";